import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const ProductsPage = lazy(() => import('@/pages/products'));

export const Route = createFileRoute('/products')({
  component: function ProductsRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <ProductsPage />
      </Suspense>
    );
  },
});
